import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utilities/axiosInstance";
import { filterRequest } from "../../utilities/apiManager";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null
}

export const getInsurance = createAsyncThunk(
  "insurance/getInsurance",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query = "", owner, user, filter = {} } = args;

      // Clean filter object - only include non-empty values
      const cleanFilter = {};
      Object.keys(filter).forEach(key => {
        const value = filter[key];
        if (value !== null && value !== undefined && value !== "") {
          cleanFilter[key] = value;
        }
      });

      const filterStr = filterRequest(cleanFilter);
      let url = `/insurance?page=${page}&size=${size}`;
      if (query) url += `&query=${query}`;
      if (owner) url += `&owner=${owner}`;
      if (user) url += `&user=${user}`;
      url += filterStr;

      const { data } = await axiosInstance.get(url);
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateInsurance = createAsyncThunk(
  "insurance/updateInsurance",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.put(
        `/insurance_histories/${args._id}`,
        args.values
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateInsuranceStatus = createAsyncThunk(
  "insurance/updateInsuranceStatus",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.put(
        `/insurance/${args._id}`,
        args.values
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const insuranceSlice = createSlice({
  name: "insurance",
  initialState,
  reducers: {
    resetInsurance: (state) => {
      state.isLoading = false;
      state.data = [];
      state.itemsCount = 0;
      state.pages = 0;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInsurance.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getInsurance.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data.data;
        state.itemsCount = payload.data.itemsCount;
        state.pages = payload.data.pages;
        state.error = null;
      })
      .addCase(getInsurance.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message
      })

      .addCase(updateInsurance.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateInsurance.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        const indexAt = state.data.findIndex(el => el._id === payload.data._id);
        state.data[indexAt] = payload.data;
        state.error = null;
      })
      .addCase(updateInsurance.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(updateInsuranceStatus.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateInsuranceStatus.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(updateInsuranceStatus.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});

export const { resetInsurance } = insuranceSlice.actions;
export default insuranceSlice.reducer;